import * as React from "react";
import { useImperativeHandle, useRef, forwardRef, useState } from "react";
import "./AcordeContactForm.scss";
import { ClassableProps, baseClassAnd, childClassClosure, isNullOrEmpty } from "@jcharlesworthuk/your-mum-core/dist/functions";
import NiceTextField from "@jcharlesworthuk/your-mum-frontend/components/forms/NiceTextField";
import NiceTextareaField from "@jcharlesworthuk/your-mum-frontend/components/forms/NiceTextareaField";
import { NewContactFormEnquiryRequest } from "@ApiModels";
import ActionButton from "@jcharlesworthuk/your-mum-frontend/components/buttons/ActionButton";
import { ButtonState } from "@jcharlesworthuk/your-mum-frontend/models";
import { createInputChangeHandler } from "@jcharlesworthuk/your-mum-frontend/helpers/InputDelegates";
import { publicApiClient } from "../../ApiClient";

const baseClass = 'acorde-contact-form';
const childClass = childClassClosure(baseClass);

type Props = ClassableProps & {
  buttonText?: string;
  placeholder?: string;
};


const AcordeContactForm: React.FunctionComponent<Props> = (props: Props) => {
    const [ inputs, setInputs ] = useState<NewContactFormEnquiryRequest>({ name: '', email: '', message: ''});
    const [buttonState, setButtonState] = useState<ButtonState>(ButtonState.Disabled);
    const [resultMessage, setResultMessage ] = useState<string | null>(null);

    const registerInputChangeHandler = createInputChangeHandler<NewContactFormEnquiryRequest>(setInputs, newInputs => {
        const isValid = !isNullOrEmpty(newInputs.email) && !isNullOrEmpty(newInputs.name) && !isNullOrEmpty(newInputs.message);
        setButtonState(isValid ? ButtonState.Enabled : ButtonState.Disabled);
    });

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const action = async () => {
            setButtonState(ButtonState.Working);
            await publicApiClient.makeContactEnquiry(inputs);
            setResultMessage('Thank you for your enquiry, we will be in touch soon');
        };
        action();
    }

    return resultMessage
    ? <p>{resultMessage}</p>
    : <form onSubmit={handleSubmit} className={baseClassAnd(baseClass, props)}>
        <NiceTextField
            className={childClass('text-field')}
            type='text'
            label="Your Name"
            value={inputs.name || ''}
            onChange={registerInputChangeHandler('name', inputs)} />
        <NiceTextField
            className={childClass('text-field')}
            type='email'
            label="Your Email"
            value={inputs.email || ''}
            onChange={registerInputChangeHandler('email', inputs)} />
        <NiceTextareaField
            className={childClass('textarea-field')}
            label="Message"
            value={inputs.message || ''}
            onChange={registerInputChangeHandler('message', inputs)} />
            
        <div className={childClass('button-container')}>
            <ActionButton
                type='submit'
                size='large'
                state={buttonState}
                label='Send Message'
            />
        </div>
    </form>
}
export default AcordeContactForm;
